/**
 * @file Opens a URL in a new browser tab.
 */
const NEW_TAB_TARGET = "_blank";

/**
 * Opens the given URL in a new browser tab.
 */
const openNewTab = (url: string): void => {
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.target = NEW_TAB_TARGET;

  document.body.append(anchor);

  anchor.click();
  anchor.remove();
};

export default openNewTab;
